import {conversationClosingReply} from '../../../../supabase/functions/_shared/fluConversationClosing';
import {conceptualConsultation} from '../../../../supabase/functions/_shared/fluConsultationMode';

export type VoiceRequestIntent='operational'|'conceptual'|'closing'|'missing'|'stale';
/** ASR is independent of response generation. Never dispatch a spoken tool call
 * until the matching current input is available. This is a restrictive guard,
 * not authorization: ordinary tool permissions and confirmation still apply.
 */
export function createVoiceRequestIntent(timeoutMs=8000){
 let current:number|null=null,value:VoiceRequestIntent|undefined,transcript:string|null=null;
 let waiting:Promise<VoiceRequestIntent>|undefined,resolve:((v:VoiceRequestIntent)=>void)|undefined;
 let timer:ReturnType<typeof setTimeout>|undefined;
 const finish=(next:VoiceRequestIntent)=>{value=next;clearTimeout(timer);timer=undefined;resolve?.(next);resolve=undefined;};
 const cancel=()=>{finish('stale');current=null;waiting=undefined;transcript=null;};
 return {
  begin(turn:number){cancel();current=turn;value=undefined;},
  accept(turn:number,text:unknown){
   if(current!==turn||value!==undefined||typeof text!=='string'||!text.trim())return;
   transcript=text.trim();finish(conversationClosingReply(text)?'closing':conceptualConsultation([{role:'user',content:text}])?'conceptual':'operational');
  },
  fail(turn:number){if(current===turn&&value===undefined)finish('missing');},
  wait(turn:number):Promise<VoiceRequestIntent>{
   // Turn zero / UI receipts are not invented spoken input.
   if(current===null)return Promise.resolve('operational');
   if(turn!==current)return Promise.resolve('stale');
   if(value!==undefined)return Promise.resolve(value);
   waiting??=new Promise(r=>{resolve=r;timer=setTimeout(()=>finish('missing'),timeoutMs);});
   return waiting;
  },
  transcript(turn:number){return current===turn&&value==='operational'?transcript:null;},
  closingReply(turn:number){return current===turn&&value==='closing'?conversationClosingReply(transcript):null;},
  cancel,
 };
}

export const conceptualVoiceResponse={
 tool_choice:'none',
 instructions:'Rispondi alla richiesta corrente solo come consulenza concettuale. L’utente vuole ragionare su un esempio o un assetto, senza operare: non leggere record, non navigare, non preparare proposte e non chiamare strumenti. Descrivi un primo assetto semplice come ipotesi da validare, senza chiedere nomi o date reali e senza dichiarare esecuzioni. Rispetta i vincoli dell’utente; una preferenza non è un limite del prodotto. Italiano naturale, poche frasi.',
} as const;
